export interface DictLike { // 货币类型与信用等级
  key: string;
  desc: string;
}
export interface DictLikeNumberKey { // 货币类型与信用等级
  key: number;
  desc: string;
}

export enum DictEnum {
  SALE_TYPE = "1", //  sale - 销售类型
  SALE_TRADE_TERM = "2", // sale - 贸易条款
  SALE_PAY_METHOD = "3", // sale - 付款方式
  SALE_SHIPPING_METHOD = '4', // sale - 出货方式
  SALE_CUSTOMER_TYPE = '5', // sale - 客户种类
  PURCHASE_TRADE_TERM = '6', // 供应商 - 贸易条款
  PURCHASE_PAY_METHOD = '7', // 供应商 - 付款方式
  ADDRESS_MANAGE = 'ADDRESS_MANAGE',    //已废弃
  EXCHANGE_RATE = "EXCHANGE_RATE",
  PRINT_SETTING = "PRINT_SETTING",
  BRAND = "BRAND",      //物料原厂名称
  PURCHASE_RULE = "PURCHASE_RULE",      //采购条约
  PRODUCT_TYPE = "PRODUCT_TYPE",
}

export interface DictItem {
  id: string;
  type: DictEnum;
  key: string;
  desc: string;
  value: string;
}

export interface DictInfo {
  key: string;
  desc: string;
}
// 因为后续要使用value存值，所以新定义类型并且新定义接口
export interface DictInfoVal {
  key: string;
  value: string;
}